import Grid from "@mui/material/Grid2";
import React from "react";
import AreaNotification from "./AreaNotifications";
import PostCodeInput from "./PostCodeInput";
import Paper from "@mui/material/Paper";
import { Typography } from "@mui/material";
import useDebugInformation from "../../../../../../../../hooks/useDebugInformation";
import NumberedHeader from "../../../../../../../Shared/NumberedHeader";
import { useAppSelector } from "@store/hooks";

type Props = {
    inputRef: any;
}

const PostcodeSearch: React.FC<Props> = ({ inputRef }) => {
    const problemAddressString = useAppSelector(({ ui }) => ui.ProblemAddressString)

    useDebugInformation("PostcodeSearch", { problemAddressString })
    return (
        <Paper elevation={4} sx={(theme) => ({
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
            padding: theme.spacing(2),
            [theme.breakpoints.up(600 + Number(theme.spacing(3)) * 2)]: {
                marginTop: theme.spacing(1),
                marginBottom: theme.spacing(2),
                padding: theme.spacing(2),
            },
            '& input': { height: "1em" }
        })}>
            <Grid container spacing={1}>
                <NumberedHeader number="3" description="PROPERTY SEARCH" variant={problemAddressString ? "green" : "red"} />
                <PostCodeInput inputRef={inputRef} />
                <AreaNotification />
                <Typography variant="caption" sx={{ m: "0 auto", mt: 1, maxWidth: "100ch", overflow: "hidden", whiteSpace: "nowrap" }}>{problemAddressString}</Typography>
            </Grid>
        </Paper >
    )
}

export default React.memo(PostcodeSearch)